import React from 'react';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";


import { BrowserRouter } from 'react-router-dom';
import Header from './componets/Header';
import HeroSlider from './componets/Hero';
import Footer from './componets/Footer';
import About from './componets/About';
import ContactSection from './componets/ContactSection';
import Enquiry from './componets/Enquiry';
import Onlinepayment from './pages/ClientsSectionn';
import ClientsSection from './componets/ClientsSection';
import TariffPlan from './componets/TariffPlan';
import ServicesSectionWide from './pages/ServicesSectionWide';
import TeamSection from './pages/TeamSection';
import GallerySection from './pages/GallerySection';
import Pgrooms from './pages/Pg-room';
import RulesAndRegulations from './pages/RulesAndRegulations';
import PrivacyPolicyPG from './pages/PrivacyPolicyPG';
import TermsAndConditionsPG from './pages/TermsAndConditionsPG';
import Pginpune from './pages/PG in Pune';
import Singleroompginpune from './pages/Single Room PG in Pune';
// import Pginbaner from './pages/PG in Baner';
// import Hostalsinbaner from './pages/Hostels in Baner';
// import Pginaundhbaner from './pages/PG in Aundh Baner';
// import Payingguesthostalinbaner from './pages/Paying Guest Hostel in Baner';
// import Girlshostalsinbaner from './pages/Girls Hostels in Baner';
// import Boyshostalinbaner from './pages/Boys Hostel in Baner';
// import Monthlybasispginbanerpune from './pages/Monthly Basis PG in Baner Pune';
// import Pginbanerbalewadi from './pages/PG in Baner Balewadi';
// import Pginbanerwithfood from './pages/PG in Baner With Food';
// import Pgforstudentinbanerpune from './pages/PG for Students in Baner Pune';
// import Luxurypginbaner from './pages/Luxury PG in Baner';
import Hostalinpune from './pages/Hostel in Pune';
import Pgforworkingprofessinalpune from './pages/PG for Working Professionals Pune';
import Bestluxurypginpune from './pages/Best Luxury PG in Pune';

import Payingguestnearhinjewadiitpark from './pages/Paying Guest Near Hinjewadi IT Park Pune';
import Bestpginhinjewadiphase from './pages/Best PG in Hinjewadi Phase 1 for Females with Food Near Infosys';
import Bestpginhinjewadiphaseforworkimg from './pages/Best PG in Hinjewadi Phase 3 for Working Ladies';
import Luxurypginhinjewadinearblueridge from './pages/Luxury PG in Hinjewadi Near Blue Ridge and Megapolis';
import Singlesharingpginhinjewadiformalefemale from './pages/Single Sharing PG in Hinjewadi for Male & Female';
import Couplefriendlypginhinjewadiphasenear from './pages/Couple Friendly PG in Hinjewadi Phase 2 Near Wipro';
import Hostalinhinjewadiphaseformale from './pages/Hostel in Hinjewadi Phase 3 for Male with AC Facilities';
import Pginlaxmichowkhinjewadinearphase from './pages/PG in Laxmi Chowk Hinjewadi Near Phase 1 & 2';
import Ladiespginhinjewadiphasenearcageminiinfosys from './pages/Ladies PG in Hinjewadi Phase 1 Near Capgemini & Infosys';
import Hillspghinjewadi from './pages/7 Hills PG Hinjewadi';
import ScrollToTop from './componets/ScrollToTop';
import ContactButtons from './componets/ContactButtons';




function App() {
  return (
    <BrowserRouter>
    
    <Header/>
     <ScrollToTop/>
<ContactButtons/>
       <Routes>

        <Route path="/" element={<HeroSlider  />} />
        <Route path="/about" element={<About  />} />
        <Route path="/term-condition" element={<TermsAndConditionsPG  />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPG  />} />
        <Route path="/rules-and-regulations" element={<RulesAndRegulations  />} />
        <Route path="/pg-room" element={<Pgrooms  />} />
        <Route path="/gallery" element={<GallerySection  />} />
        <Route path="/Services" element={<TeamSection  />} />
        <Route path="/Amenities" element={<ServicesSectionWide  />} />
        <Route path="/Tariff-Plan" element={<TariffPlan  />} />
        <Route path="/contact" element={<ContactSection  />} />
        <Route path="/Online-Pay" element={<ClientsSection  />} />
        <Route path="/enquiry" element={<Enquiry  />} />
        <Route path="/PG-in-Pune" element={<Pginpune  />} />
<Route path="/Best-Luxury-PG-in-Pune" element={<Bestluxurypginpune />} />
       
   
<Route path="/Single-Room-PG-in-Pune" element={<Singleroompginpune />} />
{/* <Route path="/PG-in-Baner" element={<Pginbaner />} />
<Route path="/Hostels-in-Baner" element={<Hostalsinbaner />} />
<Route path="/PG-in-Aundh-Baner" element={<Pginaundhbaner />} />
<Route path="/Paying-Guest-Hostel-in-Baner" element={<Payingguesthostalinbaner />} />
<Route path="/Girls-Hostels-in-Baner" element={<Girlshostalsinbaner />} />
<Route path="/Boys-Hostel-in-Baner" element={<Boyshostalinbaner />} />
<Route path="/Monthly-Basis-PG-in-Baner-Pune" element={<Monthlybasispginbanerpune />} />
<Route path="/PG-in-Baner-Balewadi" element={<Pginbanerbalewadi />} />
<Route path="/PG-in-Baner-With-Food" element={<Pginbanerwithfood />} />
<Route path="/PG-for-Students-in-Baner-Pune" element={<Pgforstudentinbanerpune />} />
<Route path="/Luxury-PG-in-Baner" element={<Luxurypginbaner />} /> */}
<Route path="/Paying-Guest-Near-Hinjewadi-IT-Park-Pune" element={<Payingguestnearhinjewadiitpark />} />
<Route path="/PG-for-Working-Professionals-Pune" element={<Pgforworkingprofessinalpune />} />
<Route path="/Hostel-in-Pune" element={<Hostalinpune />} />

<Route path="/Best-PG-in-Hinjewadi-Phase-1-for-Females-with-Food-Near-Infosys" element={<Bestpginhinjewadiphase />} />
<Route path="/Best-PG-in-Hinjewadi-Phase-3-for-Working-Ladies" element={<Bestpginhinjewadiphaseforworkimg />} />
<Route path="/Luxury-PG-in-Hinjewadi-Near-Blue-Ridge-and-Megapolis" element={<Luxurypginhinjewadinearblueridge />} />
<Route path="/Single-Sharing-PG-in-Hinjewadi-for-Male-and-Female" element={<Singlesharingpginhinjewadiformalefemale />} />
<Route path="/Couple-Friendly-PG-in-Hinjewadi-Phase-2-Near-Wipro" element={<Couplefriendlypginhinjewadiphasenear />} />
<Route path="/Hostel-in-Hinjewadi-Phase-3-for-Male-with-AC-Facilities" element={<Hostalinhinjewadiphaseformale />} />
<Route path="/PG-in-Laxmi-Chowk-Hinjewadi-Near-Phase-1-and-2" element={<Pginlaxmichowkhinjewadinearphase />} />
<Route path="/Ladies-PG-in-Hinjewadi-Phase-1-Near-Capgemini-and-Infosys" element={<Ladiespginhinjewadiphasenearcageminiinfosys />} />
<Route path="/7-Hills-PG-Hinjewadi" element={<Hillspghinjewadi />} />

      </Routes>
     <Footer/>
    </BrowserRouter>
  );
}

export default App;
